/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Object contains attachment id for sap attachment.
 * @export
 * @interface SAPAttachment
 */
export interface SAPAttachment {
    /**
     * Attachment identifier.
     * @type {string}
     * @memberof SAPAttachment
     */
    id?: string;
    /**
     * The name and the extension of the attached file.
     * @type {string}
     * @memberof SAPAttachment
     */
    filename?: string;
}

/**
 * Check if a given object implements the SAPAttachment interface.
 */
export function instanceOfSAPAttachment(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SAPAttachmentFromJSON(json: any): SAPAttachment {
    return SAPAttachmentFromJSONTyped(json, false);
}

export function SAPAttachmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAPAttachment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'filename': !exists(json, 'filename') ? undefined : json['filename'],
    };
}

export function SAPAttachmentToJSON(value?: SAPAttachment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'filename': value.filename,
    };
}

